import rugietLogo from '@/assets/logos/rugiet/logo.svg';

export default function FullLoadingScreen() {
  return (
    <div className="fixed inset-0 flex flex-col justify-center items-center bg-paper">
      <img src={rugietLogo} alt="Survey Logo" className="mb-4 max-w-[140px]" />
    </div>
  );
}
